import { ComponentProps } from "react";

import { useField } from "formik";
import { TextInput, useTheme } from "react-native-paper";

type Props = ComponentProps<typeof TextInput> & {
  fieldName: string;
};
export default function FormikTextInput({ fieldName, style, ...props }: Props) {
  const [field, meta] = useField<string>(fieldName);
  const { colors } = useTheme();

  return (
    <TextInput
      mode="outlined"
      returnKeyType="done"
      // eslint-disable-next-line react-native/no-inline-styles
      style={[{ textAlign: "auto" }, style]}
      value={field.value}
      onChangeText={field.onChange(fieldName)}
      onBlur={field.onBlur(fieldName)}
      placeholderTextColor={colors.onSurfaceDisabled}
      dense
      outlineColor={meta.error && meta.touched ? colors.error : undefined}
      {...props}
    />
  );
}
